import React from 'react';
import { Button, Spinner } from '@telus-uds/components-web';
import PropTypes from 'prop-types';

const OrderButton = ({
  button,
  isOrderValidating,
  actionChanged,
  isDisabled
}) => {
  const { label, onClick, variant } = button;
  // Map variant string to UDS variant object
  const getVariant = () => {
    if (variant === 'purple') {
      return { priority: 'high' };
    }
    return { priority: 'high' }; // default
  };

  // Parent-provided isDisabled is authoritative; otherwise gate on actionChanged.
  const isButtonDisabled = isDisabled !== undefined ? isDisabled : !actionChanged;

  return (
    <Spinner label={label} variant={{ size: 'small' }} show={isOrderValidating} inline>
      <Button
        type="button"
        variant={getVariant()}
        disabled={isButtonDisabled}
        onClick={onClick}
      >
        {label}
      </Button>
    </Spinner>
  );
};

OrderButton.propTypes = {
  button: PropTypes.shape({
    label: PropTypes.string,
    onClick: PropTypes.func,
    variant: PropTypes.string
  }).isRequired,
  isOrderValidating: PropTypes.bool.isRequired,
  isValidated: PropTypes.bool,
  actionChanged: PropTypes.bool.isRequired,
  isDisabled: PropTypes.bool
};

export default OrderButton;
